import Vue from 'vue';
import enderecoNotaFilter from '@/filters/endereco-nota-filter';

Vue.filter('enderecoNota', enderecoNotaFilter);
